/*
  jl-card-booking

  The arrow on a product card, and the button on a tier card, add the item to
  the Booqable cart.

  Booqable has no public JS API for this, and its embed cannot be styled into a
  single button: dropped into a card it renders a whole product card of its own.
  So every card carries that embed out of sight, and the arrow forwards the
  click to the add to cart button inside it.

  Booqable only mounts embeds that were in the markup at page load, and on a
  long grid some of them come back empty. The click still never leaves the
  category or occasion page: it waits for the widget, and if it never turns up
  the button simply drops its busy state.
*/
(function () {
  var WAIT_MS = 2500;

  function findButton(card) {
    var host = card.querySelector('.jl-card__booqable');
    if (!host) return null;

    var direct = host.querySelector('button, [type="submit"], a[role="button"]');
    if (direct) return direct;

    // Booqable builds its controls from styled divs as often as from real
    // buttons, so the add to cart is also looked up by its label. The widget is
    // English regardless of the shop language, hence the plain strings.
    var nodes = host.querySelectorAll('div, span, a');
    for (var i = 0; i < nodes.length; i++) {
      var text = (nodes[i].textContent || '').trim().toLowerCase();
      if (text === 'add to cart' || text === 'book now' || text === 'add to booking' || text === 'check availability') {
        return nodes[i];
      }
    }
    return null;
  }

  function waitForButton(card, done) {
    var found = findButton(card);
    if (found) return done(found);

    var host = card.querySelector('.jl-card__booqable');
    if (!host) return done(null);

    var settled = false;
    var observer = new MutationObserver(function () {
      var btn = findButton(card);
      if (!btn || settled) return;
      settled = true;
      observer.disconnect();
      done(btn);
    });
    observer.observe(host, { childList: true, subtree: true });

    window.setTimeout(function () {
      if (settled) return;
      settled = true;
      observer.disconnect();
      done(null);
    }, WAIT_MS);
  }

  document.addEventListener('click', function (event) {
    var arrow = event.target.closest('[data-jl-book]');
    if (!arrow) return;

    // Product cards, the tier cards on Sweet 16 and the rows of the chairs list
    // all carry the embed.
    var card = arrow.closest('.jl-card, .jl-tiers__card, .jl-chairs__row, .jl-cpick__card');
    if (!card) return;

    var button = findButton(card);
    if (button) {
      // The widget is ready: book in place, no navigation.
      event.preventDefault();
      button.click();
      return;
    }

    // Not ready yet: give the widget a moment. If it never turns up there is
    // nothing else to do — the card must not navigate to the product page.
    event.preventDefault();
    arrow.setAttribute('aria-busy', 'true');
    waitForButton(card, function (btn) {
      arrow.removeAttribute('aria-busy');
      if (btn) btn.click();
    });
  });
})();

/*
  The other half of the same click. A card that could not book in place sends
  the shopper here with book=1, and the single widget on the product page - which
  always mounts, unlike one of eighteen in a grid - is clicked as soon as it is
  ready.
*/
(function () {
  if (window.location.search.indexOf('book=1') === -1) return;

  var WAIT_MS = 8000;
  var root = document.querySelector('.jl-booking');
  if (!root) return;

  function findButton() {
    var direct = root.querySelector('button, [type="submit"]');
    if (direct) return direct;
    var nodes = root.querySelectorAll('div, span, a');
    for (var i = 0; i < nodes.length; i++) {
      var text = (nodes[i].textContent || '').trim().toLowerCase();
      if (text === 'add to cart' || text === 'book now' || text === 'add to booking') {
        return nodes[i];
      }
    }
    return null;
  }

  var done = false;
  function tryClick() {
    if (done) return;
    var btn = findButton();
    if (!btn) return;
    done = true;
    observer.disconnect();
    btn.click();
    // Leave the address bar clean, so a reload does not book a second time.
    if (window.history && window.history.replaceState) {
      window.history.replaceState({}, '', window.location.pathname);
    }
  }

  var observer = new MutationObserver(tryClick);
  observer.observe(root, { childList: true, subtree: true });
  tryClick();
  window.setTimeout(function () { done = true; observer.disconnect(); }, WAIT_MS);
})();